export enum LookupType {
  IDENTITY_TYPE = 'IDENTITY_TYPE',
  FINANCIAL_ENTITY = 'FINANCIAL_ENTITY',
  LOAN_TYPE = 'LOAN_TYPE',
  EMPLOYER_SECTOR = 'EMPLOYER_SECTOR',
}

export const lookupAccess: Record<LookupType, 'PUBLIC' | 'PRIVATE'> = {
  [LookupType.IDENTITY_TYPE]: 'PUBLIC',
  [LookupType.FINANCIAL_ENTITY]: 'PUBLIC',
  [LookupType.LOAN_TYPE]: 'PRIVATE',
  [LookupType.EMPLOYER_SECTOR]: 'PRIVATE',
};
